import { observer } from 'mobx-react-lite';
import { ListPage } from 'src/components/FormPages/ListPage';
import { SettingsNotificationTemplatesStore } from 'src/stores/SettingsStores/SettingsNotificationTemplatesStore/SettingsNotificationTemplatesStore';

export const NotificationTemplateList = observer(() => {
    return (
        <ListPage
            pageName="setting-notification-templates"
            store={SettingsNotificationTemplatesStore}
            data-testid="setting-notification-templates-list"
        />
    );
});
